import { memo } from 'react';

import { Tooltip, Typography } from '@material-ui/core';

import type { MetricEvent } from '@spotify-internal/csr-player';

import { formatPlaybackTime } from '../../utils';

import styles from './EventMarker.module.css';

export type EventMarkerData = MetricEvent & {
  position: number;
  color: string;
  label?: string;
};

type EventMarkerProps = {
  marker: EventMarkerData;
  onClick: (marker: MetricEvent) => void;
};

export const EventMarker = memo(({ marker, onClick }: EventMarkerProps) => {
  const formattedTime = formatPlaybackTime(marker.timestamp * 1000);
  const tooltipText = marker.label ?? `${marker.displayName} event`;
  return (
    <Tooltip
      arrow
      interactive
      placement="bottom"
      title={
        <Typography variant="body2">
          {tooltipText}, {formattedTime}
        </Typography>
      }
    >
      <button
        type="button"
        aria-label={`${tooltipText} at ${formattedTime}`}
        className={styles.marker}
        style={{
          left: `${marker.position}%`,
          background: marker.color,
        }}
        onClick={() => onClick(marker)}
        data-track-id="button.event-marker"
        data-track-action="seek"
        data-track-data-event-type={marker.name}
      />
    </Tooltip>
  );
});
EventMarker.displayName = 'EventMarker';
